import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84b10d08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content" }

import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
import { ToolbarStates } from '@/types/toolbar'

import ElementStylePanel from './ElementStylePanel/index.vue'
import ElementPositionPanel from './ElementPositionPanel.vue'
import ElementAnimationPanel from './ElementAnimationPanel.vue'
import SlideDesignPanel from './SlideDesignPanel.vue'
import SlideAnimationPanel from './SlideAnimationPanel.vue'
import MultiPositionPanel from './MultiPositionPanel.vue'
import SymbolPanel from './SymbolPanel.vue'
import { useI18n } from 'vue-i18n'
interface ElementTabs {
  label: string
  value: ToolbarStates
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n()

const mainStore = useMainStore()
const { activeElementIdList, handleElement, toolbarState } = storeToRefs(mainStore)

const elementTabs = computed<ElementTabs[]>(() => {
  if (handleElement.value?.type === 'text') {
    return [
      { label: t(`editor.toolbar.index.style`), value: ToolbarStates.EL_STYLE },
      { label: t(`editor.toolbar.index.symbol`), value: ToolbarStates.SYMBOL },
      { label: t(`editor.toolbar.index.position`), value: ToolbarStates.EL_POSITION },
      { label: t(`editor.toolbar.index.animation`), value: ToolbarStates.EL_ANIMATION },
      // { label: '样式', value: ToolbarStates.EL_STYLE },
      // { label: '符号', value: ToolbarStates.SYMBOL },
      // { label: '位置', value: ToolbarStates.EL_POSITION },
      // { label: '动画', value: ToolbarStates.EL_ANIMATION },
    ]
  }
  return [
    { label: t(`editor.toolbar.index.style`), value: ToolbarStates.EL_STYLE },
    { label: t(`editor.toolbar.index.position`), value: ToolbarStates.EL_POSITION },
    { label: t(`editor.toolbar.index.animation`), value: ToolbarStates.EL_ANIMATION },
  ]
})
const slideTabs = [
  { label: t(`editor.toolbar.index.design`), value: ToolbarStates.SLIDE_DESIGN },
  { label: t(`editor.toolbar.index.slideAnimation`), value: ToolbarStates.SLIDE_ANIMATION },
  { label: t(`editor.toolbar.index.animation`), value: ToolbarStates.EL_ANIMATION },
]
const multiSelectTabs = [
  { label: t(`editor.toolbar.index.style`), value: ToolbarStates.EL_STYLE },
  { label: t(`editor.toolbar.index.position`), value: ToolbarStates.MULTI_POSITION },
]

const setToolbarState = (value: ToolbarStates) => {
  mainStore.setToolbarState(value)
}

const currentTabs = computed(() => {
  if (!activeElementIdList.value.length) return slideTabs
  else if (activeElementIdList.value.length > 1) return multiSelectTabs
  return elementTabs.value
})

watch(currentTabs, () => {
  const currentTabsValue: ToolbarStates[] = currentTabs.value.map(tab => tab.value)
  if (!currentTabsValue.includes(toolbarState.value)) {
    mainStore.setToolbarState(currentTabsValue[0])
  }
})

const currentPanelComponent = computed(() => {
  const panelMap = {
    [ToolbarStates.EL_STYLE]: ElementStylePanel,
    [ToolbarStates.EL_POSITION]: ElementPositionPanel,
    [ToolbarStates.EL_ANIMATION]: ElementAnimationPanel,
    [ToolbarStates.SLIDE_DESIGN]: SlideDesignPanel,
    [ToolbarStates.SLIDE_ANIMATION]: SlideAnimationPanel,
    [ToolbarStates.MULTI_POSITION]: MultiPositionPanel,
    [ToolbarStates.SYMBOL]: SymbolPanel,
  }
  return panelMap[toolbarState.value] || null
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentTabs), (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab", { 'active': tab.value === _unref(toolbarState) }]),
          key: tab.value,
          onClick: ($event: any) => (setToolbarState(tab.value))
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPanelComponent))))
    ])
  ]))
}
}

})